// store/modules/tooltip.js
export default {
    namespaced: true,
    state: {
        display: false,
        content: "",
        position: "",
        elementTarget: null,
    },
    mutations: {
        updateTooltipContent(state, newContent) {
            state.content = newContent;
        },
        updateTooltipDisplay(state, newDisplay) {
            state.display = newDisplay;
        },
        updateTooltipPosition(state, newPosition) {
            state.position = newPosition;
        },
        updateTooltipElementTarget(state, newElementTarget) {
            state.elementTarget = newElementTarget;
        },
    },
    getters: {
        tooltipDisplay(state) {
            return state.display;
        },
        tooltipContent(state) {
            return state.content;
        },
        tooltipPosition(state) {
            return state.position;
        },
        tooltipElementTarget(state) {
            return state.elementTarget;
        },
    },
};
